import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { prepareColor } from "../../internal/utils/prepareColor.js";
/**
 * @description Adds an outline to a transparent image. For examples, see the Image Transformations guide.
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var EffectOutline = /*#__PURE__*/function (_Action) {
  _inherits(EffectOutline, _Action);

  var _super = _createSuper(EffectOutline);

  function EffectOutline() {
    var _this;

    _classCallCheck(this, EffectOutline);

    _this = _super.call(this);
    _this._actionModel = {};
    _this._actionModel.actionType = 'outline';
    return _this;
  }
  /**
   * @description
   * How to apply the outline effect which can be one of the following values:
   * inner, inner_fill, outer, fill.
   * @param {OutlineModeType|string} mode  The type of outline effect. Use the constants defined in Outline.
   * @return {this}
   */


  _createClass(EffectOutline, [{
    key: "mode",
    value: function mode(_mode) {
      this._actionModel.mode = _mode;
      this._mode = _mode;
      return this;
    }
    /**
     * The thickness of the outline in pixels. (Range: 1 to 100, Server default: 5)
     * @param {number} width
     * @return {this}
     */

  }, {
    key: "width",
    value: function width(_width) {
      this._actionModel.width = _width;
      this._width = _width;
      return this;
    }
    /**
     * @description
     * The level of blur of the outline.
     * Range: 0 to 2000, Server default: 0
     * @param {number | string} lvl
     * @return {this}
     */

  }, {
    key: "blurLevel",
    value: function blurLevel(lvl) {
      this._actionModel.blurLevel = lvl;
      this._blurLevel = lvl;
      return this;
    }
    /**
     * @param {string | Qualifiers.Color} color One of the SDK Color values, string, or rgba: '#fff'
     * @return {this}
     */

  }, {
    key: "color",
    value: function color(_color) {
      this._actionModel.color = _color;
      return this.addQualifier(new Qualifier('co', prepareColor(_color)));
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      this.addQualifier(new Qualifier('e', new QualifierValue(['outline', this._mode, this._width, this._blurLevel]).setDelimiter(':')));
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          mode = actionModel.mode,
          color = actionModel.color,
          blurLevel = actionModel.blurLevel,
          width = actionModel.width; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this();
      mode && result.mode(mode);
      color && result.color(color);
      blurLevel && result.blurLevel(blurLevel);
      width && result.width(width);
      return result;
    }
  }]);

  return EffectOutline;
}(Action);

export { EffectOutline };